import React, { Component } from 'react';
import { Switch, TouchableOpacity, Image, Animated, Modal, TouchableHighlight, StyleSheet, LayoutAnimation, Platform, Picker as rnPicker } from 'react-native';
import { Text, Icon, IconNB, Input, List, ListItem, InputGroup, TextInput, CheckBox, Item, Label, Left, View, Right, Button, Picker as nbPicker } from 'native-base';
import Slider from '@react-native-community/slider';
import DatePicker from '../components/rn-datepicker';
import FontAwesome from 'react-native-vector-icons/FontAwesome';

function minusOf(val, currency) {
	val = Math.abs(val);
	if (currency) return (0 - Number(val)).toFixed(2);
	return (0 - Number(val)).toString();
}
const zeroPad = (num, places) => String(num).padStart(places, '0');
const isWeb = Platform.OS == 'web';

const redColour = '#933';
const greenColour = '#367336';
const darkGrey = '#777';

class textInput extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			showPass: false
		};
	}

	render() {
		const {
			input: { onChange, onBlur, value, ...restInput },
			label,
			returnKeyType,
			style = {},
			textAlign = 'left',
			postScript,
			multiline = false,
			selectTextOnFocus,
			disabled = false,
			secureTextEntry = false,
			allowInsecure = true,
			onEnter,
			keyboardType = 'default',
			placeholder,
			icon,
			labelType = 'inline',
			labelWidth = '25%',
			inputWidth = '100%',
			labelPress,
			refField,
			type,
			maxLength,
			numberOfLines = 1,
			autoFocus,
			labelFlex,
			uCase = false,
			boxno,
			meta: { touched, error, invalid, warning },
			custom,
			children
		} = this.props;
		const width = labelType == 'floating' || labelType == 'stacked' ? undefined : labelWidth;
		const success = touched && !error && !invalid;
		const borderColor = success ? greenColour : error ? redColour : darkGrey;

		return (
			<View>
				<View style={styles.innerContainer}>
					<View style={styles.labelContainer}>
						{icon ? <IconNB name={icon} style={{ width: 25, color: '#2f6483' }} /> : undefined}
						{!!boxno && <Text style={styles.defaultBoxNo}>{boxno}</Text>}
						{labelPress && (
							<TouchableOpacity onPress={labelPress}>
								<Icon name="help-circle" style={styles.helpCircle} />
							</TouchableOpacity>
						)}
						{label ? <Label style={styles.defaultLabel}>{label}</Label> : undefined}
					</View>

					<View style={[styles.defaultInput, { flex: 0.8, position: 'relative', backgroundColor: disabled ? null : '#FFF', borderWidth: disabled ? 0 : 0.5, borderColor }]}>
						{!!error && <Icon name="close-circle" style={{ alignSelf: 'center', margin: 3, color: redColour }} />}
						{touched && !!value && !error && <Icon name="checkmark-circle" style={{ alignSelf: 'center', margin: 3, color: greenColour }} />}
						<Input
							ref="input"
							placeholder={placeholder}
							returnKeyType={returnKeyType}
							style={numberOfLines > 1 && { height: numberOfLines * 24 }}
							style={{ width: inputWidth, textAlign, minWidth: 0 }}
							secureTextEntry={secureTextEntry || (Platform.OS == 'android' && uCase)}
							multiline={multiline}
							autoFocus={autoFocus}
							numberOfLines={numberOfLines}
							selectTextOnFocus={selectTextOnFocus}
							keyboardType={(Platform.OS == 'android' && uCase) || this.state.showPass ? 'visible-password' : keyboardType}
							disabled={disabled}
							maxLength={maxLength}
							autoCapitalize={uCase ? 'characters' : null}
							ref="input"
							value={value}
							onChangeText={uCase ? v => onChange(v.toUpperCase()) : onChange}
							onEndEditing={onBlur}
							onBlur={isWeb ? onBlur : undefined}
							placeholderTextColor="#AAA"
							{...restInput}
							onSubmitEditing={onEnter}
						/>
						{!!secureTextEntry && allowInsecure && (
							<TouchableHighlight
								underlayColor="#FFF"
								onPress={() => this.setState({ showPass: !this.state.showPass })}
								//onShowUnderlay={() => this.setState({ showPass: true })}
								//onHideUnderlay={() => this.setState({ showPass: false })}>
							>
								<Icon name={this.state.showPass ? 'eye-off' : 'eye'} />
							</TouchableHighlight>
						)}
					</View>
				</View>
				{error && <Text style={{ color: 'red', textAlign: 'right' }}>{error}</Text>}
				{children}
			</View>
		);
	}
}

const displayInput = ({ input: { onChange, ...restInput }, style = {}, meta: { touched, error, invalid, warning }, note = false, pre = '', currency = false, minus = false }) => {
	return (
		<>
			<Text style={[style, error && { borderColor: redColour, borderWidth: 1 }]} note={note}>
				{pre}
				{minus ? minusOf(restInput.value, currency) : restInput.value}
			</Text>
			{touched && error && <Text style={{ color: 'red' }}>{error}</Text>}
		</>
	);
};

class percentInput extends React.PureComponent {
	render() {
		const {
			input: { onChange, onBlur, ...restInput },
			label,
			style = { marginLeft: 5 },
			labelType = 'floating',
			disabled = false,
			type,
			boxno,
			meta: { touched, error, invalid, warning }
		} = this.props;
		const width = labelType == 'floating' ? undefined : '50%';

		return (
			<View>
				<Item
					accessible={false}
					style={styles.innerContainer}
					floatingLabel={labelType == 'floating'}
					inlineLabel={labelType == 'inline'}
					stackedLabel={labelType == 'stacked'}
					error={!!error}
					success={touched && !error && !invalid}>
					<View style={styles.labelContainer}>
						{!!boxno && <Text style={styles.defaultBoxNo}>{boxno}</Text>}
						{label ? <Label style={styles.defaultLabel}>{label}</Label> : undefined}
					</View>
					{touched && !!restInput.value && !error && <Icon name="checkmark-circle" />}
					{error ? <Icon name="close-circle" /> : undefined}
					<View style={[styles.defaultInput, { position: 'relative' }]}>
						<Input ref="input" selectTextOnFocus keyboardType={'numeric'} disabled={disabled} style={{ textAlign: 'right' }} onChangeText={onChange} onEndEditing={onBlur} {...restInput} />
						<Text style={{ position: 'relative', width: 10, height: 24, top: 13, right: 0, marginRight: 5 }}>%</Text>
					</View>
				</Item>
				{touched && error && <Text style={{ color: 'red' }}>{error}</Text>}
			</View>
		);
	}
}

class numberInput extends React.PureComponent {
	render() {
		const {
			input: { onChange, onBlur, ...restInput },
			style = {},
			label,
			currency = false,
			minus = false,
			labelType = 'inline',
			disabled = false,
			labelWidth = '25%',
			labelPress,
			type,
			maxLength,
			maxValue,
			minValue,
			upDowns = false,
			boxno,
			children,
			meta: { touched, error, invalid, warning }
		} = this.props;
		const width = labelType == 'floating' || labelType == 'stacked' ? undefined : labelWidth;
		const success = touched && !error && !invalid;
		let borderColor = success ? greenColour : error ? redColour : darkGrey;
		//val = typeof value === 'number' ? value.toString() : value;
		let { value } = this.props.input;
		//these will actually change the value!
		//__DEV__ && console.log(value);
		if (value == 'NaN') value = 0;
		if (typeof minValue == 'number' && value != '') value = Math.max(value - 0, minValue).toString();
		if (typeof maxValue == 'number' && value != '') value = Math.min(value - 0, maxValue).toString();
		if (value != this.props.input.value) onChange(value || '0');

		if (minus) value = minusOf(value, currency);

		return (
			<View>
				<View style={styles.innerContainer}>
					<View style={styles.labelContainer}>
						{!!boxno && <Text style={styles.defaultBoxNo}>{boxno}</Text>}
						{labelPress && (
							<TouchableOpacity onPress={labelPress}>
								<Icon name="help-circle" style={styles.helpCircle} />
							</TouchableOpacity>
						)}
						{label ? <Label style={styles.defaultLabel}>{label}</Label> : undefined}
					</View>
					{!!error && <Icon name="close-circle" style={{ alignSelf: 'center', margin: 3, color: redColour }} />}
					{touched && !!value && !error && <Icon name="checkmark-circle" style={{ alignSelf: 'center', margin: 3, color: greenColour }} />}
					<View style={[styles.defaultInput, { backgroundColor: 'transparent', borderWidth: upDowns ? 0 : 0.5 }]}>
						{upDowns && (
							<Button transparent style={{ justifyContent: 'flex-end' }} onPress={() => onChange((parseInt(value) - 1).toString())}>
								<Icon name="arrow-down" />
							</Button>
						)}
						<Input
							ref="input"
							selectTextOnFocus
							keyboardType={'numeric'}
							disabled={disabled}
							maxLength={maxLength}
							style={{ borderWidth: 1, borderColor, backgroundColor: 'white', borderRadius: 5, minWidth: 0, flexGrow: 0, flexShrink: 0, flexBasis: 50, textAlign: upDowns ? 'center' : 'right' }}
							onChangeText={onChange}
							onEndEditing={onBlur}
							value={value}
							onBlur={isWeb ? onBlur : undefined}
							{...restInput}
						/>
						{upDowns && (
							<Button transparent style={{ justifyContent: 'flex-start' }} onPress={() => onChange((parseInt(value) + 1).toString())}>
								<Icon name="arrow-up" />
							</Button>
						)}
					</View>
				</View>
				{children}
				{error && <Text style={{ color: 'red' }}>{error}</Text>}
			</View>
		);
	}
}

class moneyInput extends React.PureComponent {
	render() {
		const {
			input: { onChange, onBlur, value, ...restInput },
			label,
			style = {},
			placeholder,
			currency = false,
			minus = false,
			allowDecimals = true,
			labelType = 'floating',
			labelWidth = '60%',
			labelPress,
			disabled = false,
			icon,
			type,
			boxno,
			children,
			meta: { touched, error, invalid, warning, active }
		} = this.props;
		const width = labelType == 'floating' || labelType == 'stacked' ? 'auto' : labelWidth;

		//if (!value) value = 0;
		//console.log(value);
		const showInactiveZeros = allowDecimals && !!value && typeof value == 'string' && !value.includes('.') && !active;
		const success = touched && !error && !invalid;
		let borderColor = success ? greenColour : error ? redColour : darkGrey;
		//if (value != this.props.input.value) onChange(value || '0');

		return (
			<View>
				<View style={styles.innerContainer}>
					<View style={styles.labelContainer}>
						{!!icon && <Icon name={icon} size={14} style={{ fontSize: 18, alignSelf: 'center', color: '#2f6483', width: 25 }} />}
						{!!boxno && <Text style={[styles.defaultBoxNo, { marginVertical: 12 }]}>{boxno}</Text>}
						{labelPress && (
							<TouchableOpacity onPress={labelPress}>
								<Icon name="help-circle" style={styles.helpCircle} />
							</TouchableOpacity>
						)}
						<Label style={styles.defaultLabel}>{label}</Label>
					</View>

					<View style={[styles.defaultInput, { maxWidth: 180, flex: 0.8, position: 'relative', backgroundColor: disabled ? null : '#FFF', borderWidth: disabled ? 0 : 0.5, borderColor }]}>
						{!!error && <Icon name="close-circle" style={{ alignSelf: 'center', margin: 3, color: redColour }} />}
						{touched && !!value && !error && <Icon name="checkmark-circle" style={{ alignSelf: 'center', margin: 3, color: greenColour }} />}
						<Text style={{ alignSelf: 'center', margin: 3, color: '#AAA' }}>£</Text>
						<Input
							ref="input"
							underline={false}
							placeholder={placeholder}
							selectTextOnFocus
							disabled={disabled}
							keyboardType={'numeric'}
							style={[{ minWidth: 0, textAlign: 'right', width: '100%', backgroundColor: 'transparent' }, { paddingRight: showInactiveZeros ? 0 : 5 }]}
							onChangeText={v => onChange(v.replace(/[^0-9\-\.]/g, ''))}
							onEndEditing={onBlur}
							onBlur={isWeb ? onBlur : undefined}
							value={minus ? minusOf(value, currency) : value}
							{...restInput}
						/>
						{false && !!value && <Text style={{ position: 'absolute', width: 10, height: 24, top: 13, right: 5 + (showInactiveZeros ? 30 : 0) + 9 * value.length, color: '#AAA' }}>£</Text>}
						{!allowDecimals && !!value && <Text style={{ position: 'relative', width: 24, height: 24, top: 13, marginRight: 5, color: '#b3b3b3' }}>.00</Text>}
						{showInactiveZeros && <Text style={{ fontSize: 10, position: 'relative', width: 24, height: 24, top: 18, marginRight: 5, color: '#b3b3b3' }}>.00</Text>}
					</View>
				</View>
				{children}
				{!!error && <Text style={{ color: 'red', textAlign: 'right' }}>{error}</Text>}
			</View>
		);
	}
}

class renderPicker extends React.PureComponent {
	render() {
		const {
			input: { onChange, value, ...inputProps },
			label,
			prompt,
			mode = 'dialog',
			style = { flex: 1, marginLeft: 1 },
			labelType = 'inline',
			labelWidth,
			labelPress,
			children,
			disabled = false,
			boxno,
			meta: { touched, error },
			emptyText,
			allowEmpty = false,
			...pickerProps
		} = this.props;

		const width = !!labelWidth ? labelWidth : undefined;
		const flex = !!labelWidth ? null : 0.8;
		const Picker = Platform.OS == 'ios' ? nbPicker : rnPicker;
		//const borderColor=error?'red':undefined;
		var kids = children.slice(0);
		if (!!emptyText && (!value || (!!value && allowEmpty))) kids.push(<Picker.Item key={'empty'} label={emptyText} value="0" style={{ color: '#AAA' }} />);

		return (
			<View style={[styles.innerContainer, { minHeight: null }]}>
				{/* <View style={{ flexDirection: labelType == 'inline' ? 'row' : 'column' }}> */}
				<View style={styles.labelContainer}>
					{!!boxno && <Text style={[styles.defaultBoxNo, { marginVertical: 12 }]}>{boxno}</Text>}
					{labelPress && (
						<TouchableOpacity onPress={labelPress}>
							<Icon name="help-circle" style={styles.helpCircle} />
						</TouchableOpacity>
					)}
					{!!label && <Label style={[styles.labelContainer, styles.defaultLabel, { marginVertical: labelType == 'inline' ? 15 : 5 }]}>{label}</Label>}
				</View>
				<Picker
					enabled={!disabled}
					prompt={!!prompt ? prompt : label}
					iosHeader={!!prompt ? prompt : label}
					style={[styles.defaultInput, { flex }]}
					ref="input"
					error={error}
					disabled={disabled}
					selectedValue={value || '0'}
					onValueChange={v => onChange(v)}
					{...inputProps}
					{...pickerProps}>
					{kids}
				</Picker>
				{!!touched && !!error ? <Icon name="close-circle" style={{ color: 'red', margin: 5 }} /> : undefined}
				{/* </View> */}
				{!!touched && !!error && <Text style={{ color: 'red', alignSelf: 'center' }}>{error}</Text>}
			</View>
		);
	}
}

class displaySelection extends React.PureComponent {
	//like a picker but just displays. Needs items with id, (displayProperty)
	render() {
		const {
			input: { value, ...inputProps },
			label,
			prompt,
			style = { flex: 1, marginLeft: 1 },
			labelType = 'inline',
			labelWidth = '50%',
			children,
			disabled = false,
			meta: { touched, error },
			items,
			displayProperty,
			emptyText
		} = this.props;

		const width = !!labelWidth ? labelWidth : undefined;
		const flex = !!labelWidth ? null : 0.8;

		//console.log(this.props, emptyText);
		let text;
		if (!items) {
			text = '-';
		} else if (!value) {
			text = emptyText;
		} else {
			const selected = items.find(v => v.id == value);
			text = selected ? selected[displayProperty] : '?';
		}
		//console.log(text);

		return (
			<View style={style}>
				<View style={{ flex: 1, flexDirection: labelType == 'inline' ? 'row' : 'column' }}>
					{!!label && <Label style={{ width, flex, flexDirection: 'row', marginLeft: 5, marginVertical: labelType == 'inline' ? 15 : 5, color: '#2f6483' }}>{label}</Label>}
					<Label style={{ marginLeft: 8, marginVertical: 5, fontSize: 16 }}>{text}</Label>
				</View>
				{!!touched && !!error && (
					<View style={{ flexDirection: 'row' }}>
						<Icon name="close-circle" style={{ color: 'red', margin: 5, fontSize: 14 }} />
						<Text style={{ color: 'red' }}>{error}</Text>
					</View>
				)}
			</View>
		);
	}
}

class renderDateField extends React.PureComponent {
	render() {
		const {
			input: { onChange, onBlur, value, ...restInput },
			pickerStyle,
			placeholder = 'Select Date',
			label,
			disabled = false,
			labelWidth = '50%',
			displayFormat = 'ddd DD/MM/YY',
			noIcon = false,
			labelPress,
			boxno,
			meta: { touched, error, invalid, warning, active },
			children,
			...custom
		} = this.props;
		const width = !!labelWidth ? labelWidth : undefined;
		const flex = !!labelWidth ? null : 0.8;
		const success = touched && !error && !invalid;
		const borderColor = success ? greenColour : error ? redColour : darkGrey;

		//const isDate = typeof value == 'string' && !!value && value.split('-').length == 3;
		const isDate = value && ((typeof value == 'string' && value.split('-').length == 3) || (Object.prototype.toString.call(value) === '[object Date]' && !isNaN(value)));

		return (
			<View>
				<View style={styles.innerContainer}>
					<View style={!!label && styles.labelContainer}>
						{!!boxno && <Text style={styles.defaultBoxNo}>{boxno}</Text>}
						{!!labelPress && (
							<TouchableOpacity onPress={labelPress}>
								<Icon name="help-circle" style={styles.helpCircle} />
							</TouchableOpacity>
						)}
						{!!label && <Label style={styles.defaultLabel}>{label}</Label>}
					</View>
					<View style={[styles.defaultInput, { flex: 0.8, position: 'relative', backgroundColor: disabled ? null : '#FFF', borderWidth: disabled ? 0 : 0.5, borderColor }]}>
						{!!error && <Icon name="close-circle" style={{ alignSelf: 'center', margin: 3, color: redColour }} />}
						{touched && !!value && !error && <Icon name="checkmark-circle" style={{ alignSelf: 'center', margin: 3, color: greenColour }} />}
						{isWeb && !isDate ? (
							<Input
								ref="input"
								underline={false}
								placeholder="dd/mm/yyyy"
								selectTextOnFocus
								onChangeText={onChange}
								disabled={disabled}
								style={{ textAlign: 'right', width: '100%', minWidth: 0 }}
								onBlur={e => {
									const v = e.target.value;
									if (!v || typeof v != 'string') return false;
									const sp = v.split('/');
									__DEV__ && console.log(sp);
									if (sp && sp.length == 3) onChange(new Date(`${sp[2]}-${zeroPad(sp[1], 2)}-${zeroPad(sp[0], 2)}`));
									onBlur();
								}}
							/>
						) : (
							<DatePicker
								date={value}
								style={{ flex: 1 }}
								mode="date"
								placeholder={placeholder}
								format="YYYY-MM-DD"
								displayFormat={displayFormat}
								confirmBtnText="Confirm"
								cancelBtnText="Cancel"
								displayFormat="DD/MM/YY"
								disabled={disabled}
								iconComponent={noIcon ? <View /> : <Icon name="calendar" style={{ marginLeft: 5, color: '#2f6483' }} />}
								customStyles={
									pickerStyle || {
										dateIcon: {
											position: 'absolute',
											left: 0,
											top: 4,
											marginLeft: 0
										},
										dateInput: {
											paddingLeft: 5,
											borderColor: 'rgba(0, 0, 0, 0)'
											//alignItems: 'flex-end'
										}
									}
								}
								onDateChange={v => {
									onChange(v ? `${v.getFullYear()}-${zeroPad(v.getMonth() + 1, 2)}-${zeroPad(v.getDate(), 2)}` : null);
								}}
							/>
						)}
					</View>
				</View>
				{children}
				{!error && <Text style={{ color: 'red', textAlign: 'right' }}>{error}</Text>}
			</View>
		);
	}
}

class renderCheckbox extends React.PureComponent {
	render() {
		const { input, label, custom, disabled, children, style = { marginLeft: 5, paddingTop: 5, paddingBottom: 5 } } = this.props;

		return (
			<ListItem style={[style, { width: '100%' }]}>
				<Label style={{ flex: 1, color: '#2f6483' }}>{label}</Label>
				<Switch disabled={disabled} {...input} value={input.value ? true : false} onValueChange={() => input.onChange(!input.value)} />
				{children}
			</ListItem>
		);
	}
}

class renderSwitch extends React.PureComponent {
	render() {
		const {
			input,
			label,
			labelPress,
			custom,
			disabled,
			onText = 'Yes',
			offText = 'No',
			icon,
			onNonBool = true,
			offNonBool = false,
			labelWidth = '50%',
			style = {},
			children,
			boxno,
			meta: { touched, error, invalid, warning }
		} = this.props;
		const flex = !!labelWidth ? null : 0.5;

		return (
			<View>
				<View style={styles.innerContainer}>
					<View style={styles.labelContainer}>
						{!!icon && <Icon name={icon} size={14} style={{ fontSize: 18, alignSelf: 'center', color: '#2f6483' }} />}
						{!!boxno && <Text style={styles.defaultBoxNo}>{boxno}</Text>}
						{labelPress && (
							<TouchableOpacity onPress={labelPress}>
								<Icon name="help-circle" style={styles.helpCircle} />
							</TouchableOpacity>
						)}
						<View style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
							<Label style={styles.defaultLabel}>{label}</Label>
						</View>
					</View>
					<View style={[styles.defaultInput, styles.defaultSwitchContainer]}>
						<Switch
							disabled={disabled}
							{...input}
							value={input.value == onNonBool ? true : false}
							onValueChange={() => input.onChange(input.value == offNonBool ? onNonBool : offNonBool)}
							style={styles.switch}
						/>
						<Label style={styles.switchText}>{input.value == onNonBool ? onText : offText}</Label>
					</View>
				</View>
				{children}
				{!!error && <Text style={{ color: 'red', textAlign: 'right' }}>{error}</Text>}
			</View>
		);
	}
}

class renderAutoComplete extends React.PureComponent {
	//validator checks this value is in the list. Value can then be updated to reduxform. But we will need to filter here
	//data is data to choose from.
	constructor(props) {
		super(props);
		this.state = {
			query: props.input.value,
			hideResults: false
		};
	}

	doSearch(query) {
		if (!query || query === '') {
			return [];
		}

		const { data } = this.props;
		const regex = new RegExp(`${query.trim()}`, 'i');
		//this.props.input.onChange(query); //send to reduxform
		return data.filter(item => item.name.search(regex) >= 0);
	}

	renderItem(itemData) {
		const {
			input: { onChange, value, ...restInput }
		} = this.props;
		return (
			<TouchableOpacity onPress={() => this.onSelect(itemData)}>
				<Text>{itemData.name}</Text>
			</TouchableOpacity>
		);
	}

	onSelect(item) {
		if (__DEV__) console.log('selected', item);
		this.setState({ query: item.name });
		this.props.input.onChange(item.value);
	}

	render() {
		const {
			input: { onChange, value, ...restInput },
			disabled,
			pickerStyle,
			data,
			textChanged,
			renderItem,
			label,
			meta: { touched, error },
			...custom
		} = this.props;
		const { query } = this.state;
		const filteredData = this.doSearch(query);
		return (
			<View style={{ flex: 1, left: 0, position: 'absolute', right: 0, top: 0, zIndex: 1 }}>
				<Autocomplete data={filteredData} defaultValue={query} onChangeText={text => this.setState({ query: text })} placeholder={label} renderItem={d => this.renderItem(d)} />
			</View>
		);
	}
}

class renderSlider extends React.PureComponent {
	render() {
		const {
			input: { onChange, value, ...restInput },
			label,
			custom,
			disabled,
			max = 100,
			showPerc = true,
			step = 5,
			style = { marginLeft: 2, paddingTop: 5, paddingBottom: 5 },
			meta: { touched, error, invalid, warning }
		} = this.props;

		return (
			<View style={style}>
				<Item accessible={false} stackedLabel error={!!error}>
					<Label style={{ color: '#2f6483' }}>{label}</Label>
					<View style={{ width: '100%', flexDirection: 'row' }}>
						<Slider style={{ flex: 1 }} disabled={disabled} {...restInput} maximumValue={max} value={Number(value)} step={step} onValueChange={onChange} />
						{!!showPerc && <Text>{value}%</Text>}
					</View>
				</Item>
				{!!touched && !!error && <Text style={{ color: 'red' }}>{error}</Text>}
			</View>
		);
	}
}

const styles = StyleSheet.create({
	innerContainer: {
		display: 'flex',
		flexDirection: 'row',
		paddingVertical: 1,
		paddingHorizontal: 5,
		marginLeft: 0,
		marginRight: 0,
		flex: 1,
		width: '100%'
	},
	defaultInput: {
		display: 'flex',
		flexDirection: 'row',
		flex: 0.5,
		flexBasis: 20,
		borderWidth: 0.5,
		borderColor: 'gray',
		borderRadius: 5,
		justifyContent: 'center',
		backgroundColor: 'white',
		height: 45,
		alignSelf: 'center'
	},
	labelContainer: {
		flex: 1,
		flexDirection: 'row',
		alignItems: 'center'
	},
	defaultLabel: {
		flex: 1,
		paddingRight: 5,
		color: '#2f6483',
		fontSize: 15
	},
	defaultBoxNo: {
		borderColor: '#000',
		borderWidth: 1,
		margin: 0,
		padding: 2,
		flex: null,
		minWidth: 30,
		borderRadius: 5,
		textAlign: 'center'
	},
	defaultSwitchContainer: {
		display: 'flex',
		flex: 0.4,
		flexDirection: 'column',
		backgroundColor: 'transparent',
		borderWidth: 0
	},
	switch: {
		width: 50,
		alignSelf: 'center'
	},
	switchText: {
		alignSelf: 'center',
		color: '#2f6483'
	},
	helpCircle: {
		fontSize: 20,
		width: 20,
		marginLeft: 5,
		color: '#4499b9'
	}
});

export { textInput, moneyInput, renderPicker, renderDateField, renderCheckbox, percentInput, renderSwitch, numberInput, renderAutoComplete, displayInput, renderSlider, displaySelection };
